/* ==========================================================================
   MERCH EXPRESS — LOGO POLL
   --------------------------------------------------------------------------
   Votes are POSTed to a Google Apps Script Web App, which appends a row to a
   Google Sheet and returns the display percentages. See
   backend/vote-apps-script.gs for the server side and its setup steps.

   The endpoint URL comes from the Theme Editor and is rendered into
   <script type="application/json" data-me-poll-config> along with the option
   definitions, so nothing here is hard-coded.

   Email is required. The server enforces one vote per email address; the
   localStorage record below is only so a returning visitor on the same device
   goes straight to the standings instead of re-submitting.

   OFFLINE / UNCONFIGURED FALLBACK
   If no endpoint is set, or the request fails, the poll degrades to the old
   localStorage-only behaviour so the visitor still gets a completed
   interaction rather than a dead button. Those votes are NOT recorded in the
   sheet — see the console warning.

   Shape of the localStorage record:
   {
     "poll_id":    "merch-express-icon-2026",
     "updated_at": "2026-08-15T18:00:00.000Z",
     "voted_for":  "option-2" | null,
     "email":      "someone@example.com" | null,
     "results":    [ { "id": "option-1", "pct": 35 }, ... ],
     "options":    { "option-1": 128, ... }   // local fallback tallies only
   }
   ========================================================================== */
(function () {
  'use strict';

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function initPoll(root) {
    if (!root || root.dataset.mePollReady === '1') return;
    root.dataset.mePollReady = '1';

    var configEl = root.querySelector('[data-me-poll-config]');
    if (!configEl) return;

    var CONFIG;
    try {
      CONFIG = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    var OPTIONS   = CONFIG.options || [];
    var POLL_ID   = CONFIG.poll_id || 'merch-express-icon';
    var ENDPOINT  = (CONFIG.endpoint || '').trim();
    var STORE_KEY = 'me_poll_' + POLL_ID;

    if (!OPTIONS.length) return;

    var form     = root.querySelector('[data-me-poll-form]');
    var btn      = root.querySelector('[data-me-poll-submit]');
    var hint     = root.querySelector('[data-me-poll-hint]');
    var results  = root.querySelector('[data-me-poll-results]');
    var list     = root.querySelector('[data-me-poll-list]');
    var emailEl  = root.querySelector('[data-me-poll-email]');
    var errorEl  = root.querySelector('[data-me-poll-error]');

    if (!form || !btn || !results || !list) return;

    var LOCKED_LABEL  = btn.getAttribute('data-label-voted')   || 'Vote recorded';
    var SENDING_LABEL = btn.getAttribute('data-label-sending') || 'Recording your vote…';
    var VOTED_HINT    = hint ? (hint.getAttribute('data-hint-voted') || '') : '';

    var MSG = {
      email_required: errorEl ? (errorEl.getAttribute('data-msg-email-required') || 'Enter your email address to vote.') : '',
      email_invalid:  errorEl ? (errorEl.getAttribute('data-msg-email-invalid')  || "That email address doesn't look right.") : '',
      pick_required:  errorEl ? (errorEl.getAttribute('data-msg-pick-required')  || 'Choose an icon first.') : '',
      already_voted:  errorEl ? (errorEl.getAttribute('data-msg-already-voted')  || 'That email has already voted — here are the current standings.') : '',
      failed:         errorEl ? (errorEl.getAttribute('data-msg-failed')         || "We couldn't record your vote just now. Please try again.") : ''
    };

    /* ------------------------------------------------------------ storage -- */

    function seedPoll() {
      var counts = {};
      OPTIONS.forEach(function (o) { counts[o.id] = o.seed || 0; });
      return {
        poll_id: POLL_ID,
        updated_at: new Date().toISOString(),
        voted_for: null,
        email: null,
        results: null,
        options: counts
      };
    }

    function readPoll() {
      try {
        var raw = window.localStorage.getItem(STORE_KEY);
        if (!raw) return seedPoll();
        var data = JSON.parse(raw);
        if (!data || !data.options) return seedPoll();
        // heal the object if an option was added or renamed in the editor
        OPTIONS.forEach(function (o) {
          if (typeof data.options[o.id] !== 'number') data.options[o.id] = o.seed || 0;
        });
        return data;
      } catch (e) {
        return seedPoll();
      }
    }

    function writePoll(data) {
      data.updated_at = new Date().toISOString();
      try { window.localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
      return data;
    }

    /* --------------------------------------------------------- percentages -- */

    /* Local fallback only — used when there is no endpoint to ask. */
    function localResults(data) {
      var sum = OPTIONS.reduce(function (s, o) { return s + (data.options[o.id] || 0); }, 0) || 1;
      return OPTIONS.map(function (o) {
        return { id: o.id, pct: Math.round(((data.options[o.id] || 0) / sum) * 100) };
      });
    }

    function optionById(id) {
      for (var i = 0; i < OPTIONS.length; i++) if (OPTIONS[i].id === id) return OPTIONS[i];
      return null;
    }

    function escapeHtml(str) {
      return String(str).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    /* ---------------------------------------------------------- rendering -- */

    function renderResults(rows, votedFor) {
      if (!rows || !rows.length) return;
      list.innerHTML = '';

      rows.slice()
        .sort(function (a, b) { return b.pct - a.pct; })
        .forEach(function (r) {
          var o = optionById(r.id);
          if (!o) return;

          var row = document.createElement('div');
          row.className = 'me-res' + (votedFor === r.id ? ' is-mine' : '');
          row.innerHTML =
            '<img src="' + escapeHtml(o.image) + '" alt="" loading="lazy">' +
            '<div>' +
              '<div class="me-res__label">' + escapeHtml(o.label) + '</div>' +
              '<div class="me-res__bar"><div class="me-res__fill"></div></div>' +
            '</div>' +
            '<div class="me-res__pct">' + r.pct + '%</div>';
          list.appendChild(row);

          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              row.querySelector('.me-res__fill').style.width = r.pct + '%';
            });
          });
        });

      results.classList.add('is-open');
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || '';
      errorEl.classList.toggle('is-visible', !!msg);
      if (emailEl) emailEl.setAttribute('aria-invalid', msg ? 'true' : 'false');
    }

    function setSending(on) {
      btn.disabled = on;
      btn.textContent = on ? SENDING_LABEL : btn.getAttribute('data-label-idle');
      form.classList.toggle('is-sending', on);
    }

    function lockForm(votedFor) {
      Array.prototype.forEach.call(form.querySelectorAll('input[type="radio"]'), function (input) {
        input.disabled = true;
        if (input.value === votedFor) {
          input.checked = true;
          var label = input.closest('.me-opt');
          if (label) label.classList.add('is-selected');
        }
      });
      if (emailEl) emailEl.disabled = true;
      btn.disabled = true;
      btn.textContent = LOCKED_LABEL;
      form.classList.add('is-locked');
      if (hint && VOTED_HINT) hint.textContent = VOTED_HINT;
    }

    /* ----------------------------------------------------------- submitting -- */

    /* Sent as text/plain so the browser treats it as a "simple" request and
       skips the CORS preflight — Apps Script Web Apps do not answer OPTIONS.
       The server reads the raw body, so the content type is irrelevant to it. */
    function postVote(payload) {
      return fetch(ENDPOINT, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow'
      }).then(function (res) {
        if (!res.ok) throw new Error('http_' + res.status);
        return res.json();
      });
    }

    /* Endpoint missing or unreachable: complete the interaction locally so the
       visitor never sees a dead button. Not recorded in the sheet. */
    function fallbackVote(picked) {
      if (window.console && console.warn) {
        console.warn('[me-poll] vote not recorded server-side — falling back to localStorage.');
      }
      var data = readPoll();
      if (!data.voted_for) {
        data.options[picked] = (data.options[picked] || 0) + 1;
        data.voted_for = picked;
        data.results = localResults(data);
        writePoll(data);
      }
      lockForm(data.voted_for);
      renderResults(data.results || localResults(data), data.voted_for);
    }

    /* -------------------------------------------------------------- events -- */

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;
      Array.prototype.forEach.call(form.querySelectorAll('.me-opt'), function (label) {
        label.classList.toggle('is-selected', label.contains(e.target));
      });
      showError('');
    });

    if (emailEl) {
      emailEl.addEventListener('input', function () { showError(''); });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (form.classList.contains('is-locked') || form.classList.contains('is-sending')) return;

      var picked = form.querySelector('input[type="radio"]:checked');
      var email  = emailEl ? emailEl.value.trim() : '';

      /* email is mandatory — checked before the pick so the required field
         is what gets focus when both are missing */
      if (!email) {
        showError(MSG.email_required);
        if (emailEl) emailEl.focus();
        return;
      }
      if (!EMAIL_RE.test(email)) {
        showError(MSG.email_invalid);
        if (emailEl) emailEl.focus();
        return;
      }
      if (!picked) {
        showError(MSG.pick_required);
        return;
      }

      showError('');

      if (!ENDPOINT) {
        fallbackVote(picked.value);
        return;
      }

      setSending(true);

      postVote({
        poll_id: POLL_ID,
        email: email,
        option: picked.value,
        page: window.location.href
      }).then(function (res) {
        setSending(false);

        if (res && res.ok) {
          var data = readPoll();
          data.voted_for = res.voted_for || picked.value;
          data.email = email;
          data.results = res.results || null;
          writePoll(data);

          lockForm(data.voted_for);
          renderResults(data.results, data.voted_for);
          results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }

        if (res && res.error === 'already_voted') {
          var prev = readPoll();
          prev.voted_for = res.voted_for || prev.voted_for;
          prev.email = email;
          prev.results = res.results || prev.results;
          writePoll(prev);

          showError(MSG.already_voted);
          lockForm(prev.voted_for);
          renderResults(prev.results, prev.voted_for);
          results.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          return;
        }

        if (res && (res.error === 'bad_email')) {
          showError(MSG.email_invalid);
          if (emailEl) emailEl.focus();
          return;
        }

        throw new Error((res && res.error) || 'unknown');

      }).catch(function () {
        setSending(false);
        showError(MSG.failed);
        fallbackVote(picked.value);
      });
    });

    /* ------------------------------------------------------- restore state -- */

    var initial = readPoll();
    if (initial.voted_for) {
      lockForm(initial.voted_for);
      renderResults(initial.results || localResults(initial), initial.voted_for);
    } else {
      /* the markup ships the button disabled so a failed script load can't
         submit the form — now that we're wired up, switch it on */
      btn.disabled = false;
    }

    /* console helper for testing: MEPoll.reset() */
    window.MEPoll = {
      state:    function () { return readPoll(); },
      json:     function () { return JSON.stringify(readPoll(), null, 2); },
      endpoint: function () { return ENDPOINT || '(not configured)'; },
      reset:    function () { window.localStorage.removeItem(STORE_KEY); window.location.reload(); }
    };
  }

  function initAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-me-poll]'), initPoll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // re-init when the section is reloaded inside the Theme Editor
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-me-poll]');
    if (root) initPoll(root);
  });
})();
